module.exports = __webpack_public_path__ + "img/banner1.63890b18.png";